import type { DealActivityType } from "../types";
import { DealActivityTypeCreate } from "./DealActivityTypeCreate";
import { DealActivityTypeEdit } from "./DealActivityTypeEdit";
import { DealActivityTypeList } from "./DealActivityTypeList";

/**
 * Almikia Epic EA (TASK-113): "Actividades" -- direccion-only (see each
 * screen's own `CanAccess` gate). No `show`: the list already surfaces every
 * field a direccion user needs to decide whether to open an activity's edit
 * form, mirroring `stageConfigs`.
 */
export default {
  list: DealActivityTypeList,
  edit: DealActivityTypeEdit,
  create: DealActivityTypeCreate,
  recordRepresentation: (record: DealActivityType) => record.name,
};
